<template>
    <div class="honor">
      <div class="content">
      <div class="title wow fadeInUp">
          {{$t('about').honor.text0}}
      </div>
          <div class="allHonor wow fadeInUp">
              <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
                  <swiper-slide class="item" v-for="(item,index) in list" :key="index">
                      <div class="one" >
                          <img  :src="`http://www.icoolglobal.cn/${item.picurl}`" alt="">
                      </div>
                      <p>{{item.title}}</p>
                  </swiper-slide>
              </swiper>
          </div>
    </div>
    </div>
</template>

<script>
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    import {getAbout} from "../util/lang";
    export default {
        name: "brand",
        data(){
            return{
                list:[],
                swiperOptionTop: {
                    notNextTick: true,
                    centeredSlides : true,
                    // slideToClickedSlide: true,
                    slidesPerView:5,//一行显示3个
                    speed:1000,
                    initialSlide :2,
                    init:false,
                    loop:true,
                    spaceBetween :10,
                    setWrapperSize :true,
                    autoplay: false,
                    slideToClickedSlide: true,
                    breakpoints: {
                        1000: {  //当屏幕宽度大于等于1280
                            slidesPerView:1,//一行显示3个
                            initialSlide :1,
                        }
                    }
                },
            }
        },
        // props:[
        //     'certificate'
        // ],
        components:{
            swiper, swiperSlide
        },
        mounted() {
            this.$nextTick(()=>{
                this.getAbout()
            })
            setTimeout(()=>{
                this.$refs.swiperTop.swiper.init();
            },100)
        },
        methods:{
            getAbout(){
                const url =`${getAbout()}`
                this.$axios.get(url).then(res=>{
                    this.list=res.data.certificate
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
 .honor{
     width:100%;
     position: relative;
     .content{
         width:80%;
         margin: 0 auto;
         .title{
             color:#343434;
             font-size: 38px;
             font-family: "SOURCEHANSANSCN-MEDIUM";
             text-align: center;
             animation-duration: 2s;
         }
         .allHonor{
             width:100%;
             margin: 60px auto;
             position: relative;
             animation-duration: 2s;
             .gallery-top{
                 width:90%;
                 margin: 0 auto;
                 .item{
                     padding: 100px 0;
                     transition: all 600ms;
                     .one{
                         cursor: pointer;
                         width:100%;
                         opacity: .5;
                         transition: all 600ms;
                         img{
                             width:100%;
                             display: block;
                             object-fit: contain;
                             transition: all 600ms;
                             box-shadow: 0 0 5px #666666;
                         }
                         &:hover{
                             img{
                                 transform: scale(1.02);
                             }
                         }
                     }
                     p{
                         color:#666666;
                         font-family: "SOURCEHANSANSCN-LIGHT";
                         opacity: 0;
                         transition: all 600ms;
                         position: relative;
                         display: flex;
                         flex-direction: column;
                         align-items: center;
                         justify-content: center;
                         &::before{
                             content:'';
                             display: inline-block;
                               width:1px;
                             height:70px;
                             background-color: rgba(0,0,0,.2);
                         }
                     }
                 }
                 .swiper-slide-active{
                     transform: scale(1.4);
                     z-index: 1000;
                     .one{
                         opacity: 1;
                     }
                     p{
                         opacity: 1;
                         transform: translateY(-19px) scale(.6);
                     }
                 }
                 .swiper-slide-prev{
                     transform: scale(1.2) translateX(-15%);
                     z-index: 100;
                 }
                 .swiper-slide-next{
                     transform: scale(1.2) translateX(15%);
                     z-index: 100;
                 }
             }
         }
     }
     @media screen and (max-width:1000px){
         .content{
             width:90%;
             .title{
                 font-size: 24px;
             }
             .allHonor{
                 margin: 30px auto;
                 .gallery-top{
                     .swiper-slide-active{
                         padding: 0;
                         transform: scale(1);
                         .one{
                             img{
                                 transform: scale(.8);
                             }
                         }
                     }
                     .item{
                         padding: 20px 0;
                     }
                 }
             }
         }
     }
 }
</style>
<style>
    .swiper-scrollbar{
        height:2px !important;
       position: absolute;
        left:0;
        bottom:120px;
        width:100%;
        cursor: pointer;
    }
    .swiper-scrollbar-drag{
        background-color: #0C4EA2;
    }
</style>
